import AMapLoader from "@amap/amap-jsapi-loader";

export const MAP_SETTING = {
  GAO_DE: 1,
  HUA_WEI: 2,
  TIAN_DI_TU: 3,
  JIE_DIAN: 4,
};

export async function mapInit(webConfig) {
  try {
    const setting = webConfig.map_setting;
    if (setting === MAP_SETTING.GAO_DE || setting === MAP_SETTING.JIE_DIAN) {
      await AmapInit(webConfig);
    } else if (setting === MAP_SETTING.HUA_WEI) {
      await HuaWeiMapInit(webConfig);
    } else if (setting === MAP_SETTING.TIAN_DI_TU) {
      await TianDiTuMapInit(webConfig);
    }
  } catch (e) {
    console.error(e);
  }
}

export async function AmapInit(webConfig) {
  window._AMapSecurityConfig = {
    securityJsCode: webConfig.gaode_js_code || process.env.VUE_APP_GAODE_CODE,
  };
  return await AMapLoader.load({
    key: webConfig.gaode_js_key || process.env.VUE_APP_GAODE_KEY,
    plugins: [
      "AMap.ToolBar",
      "AMap.Scale",
      "AMap.CitySearch",
      "AMap.Geolocation",
      "AMap.Autocomplete",
      "AMap.Scale",
      "AMap.Geocoder",
      "AMap.PlaceSearch",
      "AMap.DistrictSearch",
    ],
    AMapUI: {
      version: "1.1",
    },
  });
}

export async function HuaWeiMapInit(webConfig) {
  return new Promise((resolve, reject) => {
    // 动态加载华为地图脚本
    const script = document.createElement("script");
    script.src = `https://mapapi.cloud.huawei.com/mapjs/v1/api/js?callback=initMap&key=${encodeURIComponent(
      webConfig.world_map_key
    )}`;
    script.onload = () => {
      resolve({ status: 1 });
    };
    script.onerror = () => {
      reject({
        status: 0,
        message: "华为地图API加载失败",
      });
    };
    document.head.appendChild(script);
  });
}

export async function TianDiTuMapInit(webConfig) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${webConfig.tdt_client_key}`;
    script.onload = () => {
      resolve({ status: 1 });
    };
    script.onerror = () => {
      reject({
        status: 0,
        message: "天地图API加载失败",
      });
    };
    document.head.appendChild(script);
  });
}
